import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <path fill="currentColor" d="M60 80V0L20 40z" fillRule="evenodd" />
  </svg>
);

const IconArrowLeft = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconArrowLeft;
